// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"90":"2357c579","96":"bbfb1845","108":"d60b22ed","183":"fe20d5e2","229":"0b5f1332","504":"ef34eeda","558":"d589d59c"}[chunkId] + ".chunk.js";
};